import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectExcludeWords = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('description_exclude')(jsonQuery),
);
